/** Returning false cancels the navigation. */
export type NavigationGuard = (to: string) => boolean;

// Module-level, not React state: AppLink's onClick and useAppNavigate's returned
// function both need to read the current guards without re-rendering to get them.
const guards = new Set<NavigationGuard>();

/** Registers a guard for as long as a form holds unsaved edits. */
export const registerNavigationGuard = (
  guard: NavigationGuard,
): (() => void) => {
  guards.add(guard);
  return () => {
    guards.delete(guard);
  };
};

/** False when a guard cancelled this navigation. Stops at the first refusal. */
export const runNavigationGuards = (to: string): boolean => {
  for (const guard of guards) {
    if (!guard(to)) return false;
  }
  return true;
};

/** Test seam. */
export const clearNavigationGuards = () => {
  guards.clear();
};
